export enum MapLoadErrors {
  InstallationNotFound = 'INSTALLATION_NOT_FOUND',
  LoadingError = 'LOADING_ERROR',
}

export const MAP_LOAD_ERROR_TRANSLATIONS: { [key: string]: string } = {
  [MapLoadErrors.LoadingError]: '+MAP.ERRORS.LOADING_ERROR',
  [MapLoadErrors.InstallationNotFound]: '+MAP.ERRORS.INSTALLATION_NOT_FOUND',
};

export interface LocationCoordinates {
  latitude: number;
  longitude: number;
}
